/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import {useContext, useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import {initEventSource} from "../../fk/core/websocket_event_source";
import {sendTokenRequest} from "../../fk/core/token_services"

import {CodeResponse, useGoogleLogin} from '@react-oauth/google';

import {Button} from '@patternfly/react-core';

import DataContext from '../context/DataContext';
import ConnectionContext from '../context/ConnectionContext';

const Cookies = require("js-cookie");

interface GoogleFormLoginProps {
  errorCallback: Function;
}

export function GoogleFormLogin({errorCallback}: GoogleFormLoginProps) {
    const navigate = useNavigate();

    const {data, setData} = useContext(DataContext);
    const {setConnection} = useContext(ConnectionContext);

    // google auth related
    const handleGoogleAuthSuccess = (codeResponse: CodeResponse) => {
        console.info('Google login succeeded', codeResponse);
        let code = codeResponse.code;
        if (code) {
            console.info('Sending token request')
            sendTokenRequest(code).then(response => {
                console.info('Got the token', response);

                let tokens = response[0];
                let decodedIdToken = response[1];

                Cookies.set('fw-utoken', tokens.refresh_token, {expires: 30});
                Cookies.set('fw-uauthtype', 'google', {expires: 30});

                let avatar;
                if (decodedIdToken.picture) {
                    avatar = decodedIdToken.picture;
                    Cookies.set('fw-uavatar', avatar, {expires: 30});
                } else {
                    avatar = Cookies.get('fw-uavatar');
                }

                // data.username = decodedIdToken.email;
                // This won't work as there's no data at this stage sometimes
                // data.userAvatar = avatar;
                // setData(data.clone());

                initEventSource(setData,
                    setConnection,
                    decodedIdToken.email,
                    tokens.id_token,
                    'google',
                    false)
            }).catch((error => {
                console.error("Token request error", error);
            }));
        }
    };

    const handleGoogleAuthError = (errorResponse: Pick<CodeResponse, 'error' | 'error_description' | 'error_uri'>) => {
        console.error('Google login failed', errorResponse);
        errorCallback(errorResponse.error_description || errorResponse.error || 'Unknown error');
    };  

    const login = useGoogleLogin({
        onSuccess: handleGoogleAuthSuccess,
        onError: handleGoogleAuthError,
        flow: 'auth-code',
    });

    useEffect(() => {
        if (data && data.isLoggedIn) {
            navigate("/");
        }
    }, [data]);

    return (
        <Button
            variant="secondary"
            id="google-button"
            onClick={() => login()}>
            Sign in with Google
        </Button>
    );
}